import React from "react";
import { ArrowUp } from "lucide-react";

export const BackToTop = () => (
  <div className="flex justify-center border-t border-border bg-background py-6">
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      data-testid="back-to-top-button"
      className="inline-flex items-center gap-2 rounded-full border border-border px-5 py-2 text-sm text-muted-foreground transition-colors hover:border-primary hover:text-primary"
    >
      <ArrowUp size={15} /> Back to the top
    </button>
  </div>
);
